import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class waErrorText {
    static classname = 'wa-error-text';
    #replacedText = 'Вы не можете использовать эти данные.'
    #newText = $('<span>Кажется вы уже есть в нашей системе, <a class="wa-login-link" href="/login/" target="_blank">авторизуйтесь</a> по номеру телефона или email</span>')
    constructor($decorator) {
        if ($decorator.text() === this.#replacedText) {
            $decorator.html(this.#newText);
        }
    }
}